export default __webpack_public_path__ + "static/media/Blog12.8.2c258c2f.png";